<div class="ui-g loyalty-channel" *ngIf="show.datatable">
  <div class="ui-g-12">

    <app-kontable
      [title]="'channel.channels' | translate"
      [columns]="[ 'channel_code', 'channelDescription', 'storeDescription' ,
      { field: 'flg_state', title: 'common.status', bodyTemplate: stateTemplate, filterType: selectFilter, filterTemplate: stateFilter, filterOptions: {values: listStates}},
      { field: 'acmCode', title: 'common.acm', bodyTemplate: acmTemplate }]"
      [titles]="[ 'channel.channel_code', 'channel.description', 'channel.default_store_id' ]"
      [servicePermissions]="channelPermission"
      [service]="channelService"
      [paginationType]="pagination"
      [(fireNewDataAvailable)]="tableChange"
      [showGlobalFilter]="false"
      [showRecoverButton]="false"
      [showInfoButton]="false"
      [showDetailsButton]="false"
      [showAddButton]="true"
      (onAdd)="add()"
      (onEdit)="edit($event)"
      (onRemove)="remove($event)"
    ></app-kontable>

    <ng-template #stateFilter data-testid="stateFilter" let-col>
      <p-dropdown [options]="listStates" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')"></p-dropdown>
    </ng-template>

    <ng-template #stateTemplate data-testid="stateTemplate" let-row class="deleted-row">
      <span *ngIf="row.flg_state && row.flg_state == '1'" class="fa fa-trash-o" title="{{'common.deleted' | translate}}"></span>
    </ng-template>

    <ng-template #acmTemplate data-testid="acmTemplate" let-row>
      <span *ngIf="row.acmCode">{{row.acmCode}} - {{row.acmDescription}}</span>
    </ng-template>

  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-channel/loyalty-channel.component.html